import { useQuery } from '@tanstack/react-query';
import { fetch } from '../common/api/helpers.ts';
import Paginator from '../components/Paginator.tsx';
import { MouseEvent, useState } from 'react';
import moment from 'moment';
import { BsFiletypeXml, BsFiletypePdf } from 'react-icons/bs';
import { logout } from '../func.ts';
const pageSize = 50;

const TradingPartnerHome = () => {
  const [pageNumber, setPageNumber] = useState<number>(0);

  const { data: totalItems } = useQuery({
    enabled: true,
    queryKey: ['trading_partner_read_count'],
    queryFn: async () => {
      const result = await fetch<{ totalItems: number }>(
        '/api/v1/outbounddocument/read/count',
        'GET'
      );
      return result?.totalItems;
    },
  });

  const { data, isLoading } = useQuery({
    enabled: true,
    queryKey: ['trading_partner_read_all'],
    queryFn: async () =>
      await fetch<
        {
          id: number;
          documentIdentifier: string;
          timestamp: string;
          customerLocationName: string;
        }[]
      >('/api/v1/outbounddocument/read/all', 'GET'),
  });

  const download = async (
    event: MouseEvent<HTMLAnchorElement>,
    outboundDocumentId: number,
    fileType: 'xml' | 'pdf'
  ) => {
    try {
      event.preventDefault();
      const buffer = await fetch<any>(
        '/api/v1/outbounddocument/download/one/by/id',
        'GET',
        { outboundDocumentId, fileType }
      );

      const doc = data?.find(({ id }) => id === outboundDocumentId);
      const filename = `${moment(doc?.timestamp).format('YYYY_MM_DD')}_${doc?.documentIdentifier}.${fileType}`;

      const uint8Array = Uint8Array.from(buffer.data);
      const blob = new Blob([uint8Array]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.hidden = true;
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      logout(err);
    }
  };

  return (
    <div>
      <div className="row">
        <h5 className="center">My EPCIS Files</h5>
        <div className="divider" />
      </div>
      <div className="row">
        {isLoading ? (
          <div className="progress">
            <div className="indeterminate blue" />
          </div>
        ) : (
          <>
            <table className="highlight">
              <thead>
                <tr>
                  <th>Recieved From</th>
                  <th>ID</th>
                  <th>Date Sent</th>
                  <th>Downloads</th>
                </tr>
              </thead>
              <tbody>
                {data?.map(
                  ({
                    id,
                    documentIdentifier,
                    timestamp,
                    customerLocationName,
                  }) => (
                    <tr key={id}>
                      <td style={{ padding: '4px' }}>{customerLocationName}</td>
                      <td style={{ padding: '4px' }}>{documentIdentifier}</td>
                      <td style={{ padding: '4px' }}>
                        {moment(timestamp).format('MM/DD/YY h:mmA')}
                      </td>
                      <td style={{ padding: '4px' }}>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                        >
                          <a href="/" onClick={e => download(e, id, 'xml')}>
                            <BsFiletypeXml
                              style={{ fontSize: '1.7em', color: 'black' }}
                            />
                          </a>
                          <a
                            href="/"
                            onClick={e => download(e, id, 'pdf')}
                            style={{ fontSize: '1.7em', color: 'black' }}
                          >
                            <BsFiletypePdf />
                          </a>
                        </div>
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
            {data && totalItems && totalItems > pageSize && (
              <Paginator
                pageNumber={pageNumber}
                pageSize={pageSize}
                setPageNumber={setPageNumber}
                totalItems={totalItems || 0}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default TradingPartnerHome;
